import { Component, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AlertService } from './service/alert.service';
import { NavigationCancel, NavigationEnd, NavigationStart, Router } from '@angular/router';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class AppComponent implements OnInit, OnDestroy {
  private _loadings: boolean[] = [];
  private destroy$ = new Subject<void>();

  constructor(
    private _alert: AlertService,
    private _router: Router,
  ) {
    this._initalizeLoadingPage();
    this._initalizeLoadRouterEvent();
  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  /** ตรวจสอบว่ามีการโหลดหน้าเว็บหรือไม่ */
  get isLoadingPage() { return this._loadings.length > 0; }

  /** หากโหลดนานเกินไป */
  onLoadingTimeout() { this._loadings.splice(0); }

  /** โหลดข้อมูลของหน้าเว็บเมื่อสลับ Router */
  private _initalizeLoadRouterEvent() {
    this._router.events.pipe(takeUntil(this.destroy$)).subscribe(ev => {
      if (ev instanceof NavigationStart) this._alert.loadingPage(true);
      else if (ev instanceof NavigationEnd) this._alert.loadingPage(false);
      else if (ev instanceof NavigationCancel) this._alert.loadingPage(false);
    });
  }

  /** ดักจับการทำงานของโหลดหน้าเว็บทั้งหมด */
  private _initalizeLoadingPage() {
    this._alert.onLoadingPage
      .pipe(takeUntil(this.destroy$))
      .subscribe(status => status ? this._loadings.push(status) : this._loadings.pop());
  }
}
